import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getApexHeaderLogoSrc, getIslandHeaderLogoSrc, getSiteBackgroundSpec } from 'alakai-aloha-shared';
import { PublicSiteBackground } from 'alakai-aloha-shared/public-ui';
import { getRuntimeSiteContext } from '../../lib/siteContext';

const LayoutNoNav = ({
  children,
  showHeader = false,
  headerExitRoute = '/',
  className = ''
}) => {
  const navigate = useNavigate();
  const { isApexHost, island, siteVariant } = getRuntimeSiteContext();
  const headerLogoSrc = isApexHost ? getApexHeaderLogoSrc() : getIslandHeaderLogoSrc(island);
  const backgroundTheme = getSiteBackgroundSpec(siteVariant);

  return (
    <div className={`min-h-screen relative overflow-hidden ${className}`}>
      <PublicSiteBackground backgroundTheme={backgroundTheme} />

      {showHeader && (
        <header className="sticky top-0 left-0 w-full text-white pt-1 pb-1 px-4 z-50">
          <div className="max-w-6xl mx-auto">
            <div className="flex justify-between items-center">
              <button
                onClick={() => navigate('/')}
                className="flex items-center"
              >
                <img
                  src={headerLogoSrc}
                  alt="Alakai Aloha Logo"
                  className="h-10 w-auto flex-shrink sm:h-12"
                />
              </button>
              <button
                onClick={() => navigate(headerExitRoute)}
                className="text-sm font-medium hover:underline"
              >
                Exit
              </button>
            </div>
          </div>
        </header>
      )}

      <div className="relative z-20">
        {children}
      </div>
    </div>
  );
};

export default LayoutNoNav;
